window.addEventListener('error', (e) => {
	if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
		e.stopImmediatePropagation()
	}
})
// 解决 ResizeObserver loop completed with undelivered notifications. 错误


import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/styles/main.css'



// 先创建应用实例
const app = createApp(App)

// 使用插件
app.use(router).use(ElementPlus).use(store)

// 全局注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}

// 挂载到 DOM
app.mount('#app')